// Utility for handling UTM parameters
export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'ref'
];

export function getUtmParamsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const utms = {};
  UTM_KEYS.forEach(key => {
    if (params.has(key)) utms[key] = params.get(key);
  });
  return utms;
}

export function saveUtmParams(utms) {
  Object.entries(utms).forEach(([key, value]) => {
    if (value) localStorage.setItem(key, value);
  });
}

export function getSavedUtmParams() {
  const utms = {};
  UTM_KEYS.forEach(key => {
    const value = localStorage.getItem(key);
    if (value) utms[key] = value;
  });
  return utms;
}

export function buildUrlWithUtmParams(baseUrl) {
  const utms = getSavedUtmParams();
  const url = new URL(baseUrl);
  Object.entries(utms).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value);
  });
  return url.toString();
}
